"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Account = function Account($http, SERVER_URL) {
  "ngInject";

  return {
    login: login,
    confirmRegistration: confirmRegistration
  };

  function login(username, password) {
    return $http({
      url: SERVER_URL + "/authenticate",
      method: "POST",
      data: {
        username: username,
        password: password,
        rememberMe: false
      }
      //paramSerializer: '$httpParamSerializerJQLike',
      // headers: {
      //   'Authorization': 'Basic d2ViX2FwcDo=',
      //   'Content-Type': 'application/x-www-form-urlencoded'
      // },
      // transformRequest: function(obj) {
      //   var str = [];
      //   for (var p in obj) {
      //     str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      //   }
      //   return str.join('&');
      // }
    });
  };

  function confirmRegistration(key) {
    return $http({
      url: SERVER_URL + "/activate",
      method: "GET",
      params: { key: key }
    });
  }
};
exports.default = Account;


// WEBPACK FOOTER //
// ./client/app/services/accountService/account.service.js